<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-divider></v-divider>
        <v-row>
          <v-col cols="10">
            <v-list class="sae-sorting">
              <v-list-item-group class="sae-sorting-container" :value="selectedItem">
                <v-list-item v-for="(item, i) in tempList" :key="i" @change="changeSelected(i)">
                  <v-list-item-title class="text--primary" v-text="i+1"></v-list-item-title>
                  <v-list-item-title
                    class="text--primary"
                    v-for="(key,j) in headers"
                    v-bind:key="`${j}-${i}`"
                  >{{item[key]}}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="2">
            <v-container fill-height fluid>
              <v-row align="center" justify="center">
                <v-col>
                  <v-btn @click="changePos('up')">
                    <v-icon color="primary">mdi-arrow-up</v-icon>
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn @click="changePos('down')">
                    <v-icon color="primary">mdi-arrow-down</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-around">
        <v-btn @click="cancel">{{$t('cancel')}}</v-btn>
        <v-btn @click="save" color="primary">{{$t('save')}}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import numeral from 'numeral'
import _ from 'lodash'

export default {
  components: {
  },
  name: 'SortingComponent',
  props: ['loading', 'list', 'headers'],
  data() {
    return {
      tempList: [],
      tempHeader: [],
      selectedItem: null,
    }
  },
  methods: {
    changeSelected(index) {
      this.selectedItem = index
      this.$emit('change', this.selectedItem);
    },
    swapArray(arr, index1, index2) {
      [arr[index1], arr[index2]] = [arr[index2], arr[index1]]
    },
    changePos(event) {
      if (this.selectedItem < this.tempList.length-1) if (event == 'down') {
        this.swapArray(this.tempList, this.selectedItem, this.selectedItem + 1)
        this.selectedItem = this.selectedItem + 1
      }
      if (this.selectedItem > 0) if (event == 'up') {
        this.swapArray(this.tempList, this.selectedItem, this.selectedItem - 1)
        this.selectedItem = this.selectedItem - 1
      }
      this.$emit('change', this.selectedItem);
    },
    toNumeral(number) {
      return numeral(number).format("0,0");
    },
    refreshData() {
      this.tempList = []
      if (this.list) {
        this.list.map(item => {
          this.tempList.push(_.pick(item, ['id'].concat(this.headers)))
        })
      }
    },
    save() {
      this.$emit('save', this.tempList)
    },
    cancel() {
      this.$emit('cancel', true)
    }
  },
  created() {
    this.refreshData()
  },
  watch: {
    list() {
      this.refreshData()
    }
  }
}
</script>
<style>
.sae-sorting {
  min-height: 400px;
  max-height: 500px;
}
.sae-sorting-container {
  height: 400px;
  overflow: auto;
}
/* .sae-sorting-container .v-list-item--link:nth-child(odd) {
  background: rgba(138, 197, 255, 0.2);
} */

.ghost {
  border-left: 6px solid rgba(25, 118, 210, 0.14);
  box-shadow: 10px 10px 5px -1px rgba(0, 0, 0, 0.14);
}

.sae-cursor-move {
  cursor: all-scroll;
}
</style>